import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Layout,
  theme,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  Checkbox,
  Spin,
  Col,
  Radio,
  Divider,
} from "antd";

import { useNavigate, Link } from "react-router-dom";

//PROJECT IMPORTS
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
import TextArea from "antd/lib/input/TextArea";
import TopContent from "../../../components/layouts/TopContent";
import appStatic from "../../../config/appStatic";
import appLabel from "../../../config/appLabel";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import definedApi from "../../../services/definedApi";
import { newGlAccountAction } from "../../../redux/actions";
import AvailableDebitTags from "./components/AvailableDebitTags";
import AvailableCreditTags from "./components/AvailableCreditTags";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

const NewGLA0500 = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const [officeData, setOfficeData] = useState([]);
  const [accountData, setAccountData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isMultipleCreditAccount, setIsMultipleCreditAccount] = useState(false);
  const [isMultipleDebitAccount, setIsMultipleDebitAccount] = useState(false);
  const [allowedCreditTags, setAllowedCreditTags] = useState([]);
  const [allowedDebitTags, setAllowedDebitTags] = useState([]);
  const [debitTagData, setDebitTagData] = useState([]);
  const [creditTagData, setCreditTagData] = useState([]);

  useEffect(() => {
    getTemplate();
  }, []);

  function onCancel() {
    navigate("/gla0500", { replace: false });
  }

  function getTemplate() {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.AccountingRuleTemplate, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;
        let tempOffice = [];
        let tempAccountData = [];
        let tempDebitTagData = [];
        let tempCreditTagData = [];
        // console.log(objList);

        objList?.allowedOffices?.forEach((element) => {
          tempOffice.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.allowedAccounts?.forEach((element) => {
          tempAccountData.push({
            value: element.id,
            label: `${element.glCode} (${element.name})`,
            // label: element.name,
          });
        });
        objList?.allowedDebitTagOptions?.forEach((element) => {
          tempDebitTagData.push({
            id: element.id,
            name: element.name,
            available: true,
            assigned: false,
          });
        });
        objList?.allowedCreditTagOptions?.forEach((element) => {
          tempCreditTagData.push({
            id: element.id,
            name: element.name,
            available: true,
            assigned: false,
          });
        });

        setOfficeData(tempOffice);
        setAccountData(tempAccountData);
        setDebitTagData(tempDebitTagData);
        setCreditTagData(tempCreditTagData);
      }
    });
  }

  const onSubmit = (formValues) => {
    if (isMultipleDebitAccount && isMultipleCreditAccount === true) {
      formValues.creditTags = allowedCreditTags;
      formValues.debitTags = allowedDebitTags;
    } else if (isMultipleCreditAccount && isMultipleCreditAccount === false) {
      delete formValues.creditTags;
      delete formValues.debitTags;
    }

    const body = {
      ...formValues,
      method: "POST",
      session,
    };

    // console.log(body); return
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      definedApi.NewAccountingRules,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, appLabel.newAccountingRuleMsg);
          navigate("/gla0500");
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/gla0500");
          setIsLoading(false);
        },
      }
    );
  };

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={appLabel.newAccountingRules}
        pageItems={appStatic.newAccountingRulesItems}
      />
      <Spin spinning={isLoading} size="large">
        <Form layout="vertical" onFinish={onSubmit}>
          <Card
            style={{
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
          >
            <Card
              style={{
                marginBottom: "2%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
            >
              <Row style={{ justifyContent: "space-between" }}>
                <Form.Item
                  name="name"
                  label={<Text strong>{appLabel.accountingRuleName}</Text>}
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Input placeholder="xxxxxxxx" style={{ width: "30vh" }} />
                </Form.Item>

                <Form.Item
                  name="officeId"
                  label={<Text strong>{appLabel.accountingRuleOffice}</Text>}
                  rules={[
                    {
                      required: true,
                      message: "Required Field",
                    },
                  ]}
                >
                  <Select
                    style={{ width: "30vh" }}
                    placeholder="Please select office"
                    showSearch
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    options={officeData}
                  />
                </Form.Item>

                <div style={{ width: "15vh" }}></div>
              </Row>

              <Row>
                <Form.Item
                  name="description"
                  label={
                    <Text strong>{appLabel.accountingRuleDescription}</Text>
                  }
                >
                  <TextArea style={{ width: "45vh", height: "15vh" }} />
                </Form.Item>
              </Row>

              <Row style={{ justifyContent: "space-between" }}>
                <Divider orientation="left" orientationMargin="0">
                  {"Affected GL Entries"}
                </Divider>

                <div style={{ justifyContent: "center" }}>
                  <Title level={4} strong>
                    Debit Account Details
                  </Title>

                  <Radio.Group
                    onChange={() =>
                      setIsMultipleDebitAccount(!isMultipleDebitAccount)
                    }
                    value={isMultipleDebitAccount}
                  >
                    <Radio value={false}>Fixed Account</Radio>
                    <Radio value={true}>List of Accounts</Radio>
                  </Radio.Group>

                  {isMultipleDebitAccount ? (
                    <div>
                      <AvailableDebitTags
                        tagName={"Debit"}
                        debitTags={setAllowedDebitTags}
                        tags={debitTagData}
                        setTags={setDebitTagData}
                      />
                      <Form.Item>
                        <Checkbox>
                          <Text strong>Allow multiple debit entries</Text>
                        </Checkbox>
                      </Form.Item>
                    </div>
                  ) : (
                    <Form.Item
                      name="accountToDebit"
                      label={<Text strong>{appLabel.debitRuleType}</Text>}
                      style={{ marginTop: "2%" }}
                    >
                      <Select
                        placeholder="Please select debit account"
                        style={{ width: "30vh" }}
                        options={accountData}
                        showSearch
                        filterOption={(input, option) =>
                          (option?.label?.toLowerCase() ?? "").includes(
                            input?.toLowerCase()
                          )
                        }
                      />
                    </Form.Item>
                  )}
                </div>

                <div>
                  <Title level={4} strong style={{ marginBottom: "2%" }}>
                    Credit Account Details
                  </Title>

                  <Radio.Group
                    onChange={() =>
                      setIsMultipleCreditAccount(!isMultipleCreditAccount)
                    }
                    value={isMultipleCreditAccount}
                  >
                    <Radio value={false}>Fixed Account</Radio>
                    <Radio value={true}>List of Accounts</Radio>
                  </Radio.Group>

                  {isMultipleCreditAccount ? (
                    <div>
                      <AvailableCreditTags
                        tagName="Credit"
                        creditTags={setAllowedCreditTags}
                        tags={creditTagData}
                        setTags={setCreditTagData}
                      />
                      <Form.Item>
                        <Checkbox>
                          <Text strong>Allow multiple credit entries</Text>
                        </Checkbox>
                      </Form.Item>
                    </div>
                  ) : (
                    <Form.Item
                      name="accountToCredit"
                      label={<Text strong>{appLabel.creditRuleType}</Text>}
                      style={{ marginTop: "2%" }}
                    >
                      <Select
                        placeholder="Please select credit account"
                        style={{ width: "30vh" }}
                        options={accountData}
                        showSearch
                        filterOption={(input, option) =>
                          (option?.label?.toLowerCase() ?? "").includes(
                            input?.toLowerCase()
                          )
                        }
                      />
                    </Form.Item>
                  )}
                </div>

                <div style={{ width: "15vh" }}></div>
              </Row>
            </Card>

            <Form.Item>
              <Row>
                {BOM.HasPermission("CREATE_ACCOUNTINGRULE") && (
                  <CustomButton
                    content="Submit"
                    style={{
                      width: "10%",
                      marginLeft: "auto",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    }}
                    htmlType="submit"
                    backgroundColor="#15CCAE"
                    colorText="black"
                    hoverBackground="#4FECA0"
                  />
                )}
                <CustomButton
                  content="Cancel"
                  style={{
                    width: "10%",
                    marginLeft: "1%",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  backgroundColor="#fff"
                  colorText="black"
                  hoverBackground="#F5F5F5"
                  onClick={onCancel}
                />
              </Row>
            </Form.Item>
          </Card>
        </Form>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { newGlAccountAction };

export default connect(mapStateToProps, mapDispatchToProps)(NewGLA0500);
